import React from "react";

/**
 * ClassifiedFrame — the universal "classified document" section wrapper used
 * across the profile page. Standardizes:
 *   - thin top accent stripe (3px)
 *   - corner mono ``// LABEL`` header in the section's accent color
 *   - subtle radial-gradient background
 *   - soft outer glow tinted by the accent
 *
 * Usage: <ClassifiedFrame label="// PINNED THREAD" accent="#60a5fa">
 *          ...content...
 *        </ClassifiedFrame>
 */
export default function ClassifiedFrame({
  label,
  accent = "#a78bfa",
  icon: Icon = null,
  children,
  className = "",
  testid = null,
  rightSlot = null,
}) {
  return (
    <div
      data-testid={testid || undefined}
      className={`relative border overflow-hidden ${className}`}
      style={{
        borderColor: `${accent}55`,
        background: `radial-gradient(circle at 18% 20%, ${accent}0d, transparent 65%), #0a0a0a`,
        boxShadow: `0 0 0 1px ${accent}10, 0 20px 50px -28px ${accent}33`,
      }}
    >
      {/* Top stripe — the brand-wide signature of every "vault" surface */}
      <div className="absolute top-0 left-0 right-0 h-[3px]" style={{ backgroundColor: accent }} />
      <div className="px-5 sm:px-6 pt-4 pb-5">
        <div className="flex items-center justify-between gap-3 mb-3">
          <div
            className="font-mono text-[10px] tracking-[0.3em] uppercase flex items-center gap-1.5"
            style={{ color: accent }}
          >
            {Icon ? <Icon size={11} /> : null}
            {label}
          </div>
          {rightSlot ? <div>{rightSlot}</div> : null}
        </div>
        {children}
      </div>
    </div>
  );
}
